const ibcSession = '4' // 默认届
const ibcSeason = '1' // 默认赛季
const ibcRound = '1' // 默认轮次

export default {
  ibcSession,
  ibcSeason,
  ibcRound
}
